import React from 'react'
import Space from '../atoms/Space'
import { View } from '../other/html'
import ListLeftColumn from './conversationItem/ListLeftColumn'
import ListRightColumn from './conversationItem/ListRightColumn'
import { useNavigate } from 'react-router-dom'

interface Props {
  index?: number
  seen_by_dealer: boolean
  updated_at: string
  photo: string | null
  label1: string
  label2: string
  offer_hash_id: string
}

const ConversationItem = ({
  index,
  seen_by_dealer,
  updated_at,
  photo,
  label1,
  label2,
  offer_hash_id
}: Props): JSX.Element => {
  const navigate = useNavigate()
  const backgroundColor = (i: number): string => (i % 2 === 0 ? 'bg-lightGrey' : 'bg-white')
  return (
    <View
      className={`shadow-bothSmall  mb-4 ${backgroundColor(index ?? 0)} rounded-2 cursor-pointer`}
      onClick={() => {
        navigate(`/purchasing/conversations/${offer_hash_id}`)
      }}>
      <Space y={2} />
      <View className="flex justify-between">
        <ListLeftColumn photo={photo} label1={label1} label2={label2} offer_hash_id={offer_hash_id} />
        <ListRightColumn seen_by_dealer={seen_by_dealer} updated_at={updated_at} />
      </View>
      <Space y={2} />
    </View>
  )
}

export default React.memo(ConversationItem)
